import { render } from "./Signin.vue?vue&type=template&id=10bc0e7a&scoped=true"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=10bc0e7a&scoped=true&lang=css"
import "@/styles/header.css?vue&type=style&index=1&id=10bc0e7a&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=10bc0e7a&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=3&id=10bc0e7a&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bc0e7a"]])

export default __exports__